declare const require: any;
const npm = require('../../package.json');

const apiEnvs = {
  auth: window['env'] ? window['env']['authAdapterUrl'] : null,
  offersPortal: window['env'] ? window['env']['offersPortalUrl'] : null,
  calendarAdapter: window['env'] ? window['env']['calendarAdapterUrl'] : null,
  captchaSiteKey: window['env'] ? window['env']['captchaSiteKey'] : null
};

export const environment = {
  production: false,
  version: npm.version,

  // AUTH ENDPOINTS

  AUTH_API_URL: `${apiEnvs.auth}/token`,
  USER_GROUP_SEGMENT_URL: `${apiEnvs.auth}/user-groups-segment`,
  AUTH_INFO_API_URL: `${apiEnvs.auth}/token/authinfo`,
  AUTH_LOGOUT_URL: `${apiEnvs.auth}/token/logout`,
  AUTH_API_URL_CHANGE_PASSWORD: `${apiEnvs.auth}/change-password-by-username`,

  // OFFERS-PORTAL ENDPOINTS
  API_URL: apiEnvs.offersPortal,
  OFFERS_API_URL: `${apiEnvs.offersPortal}/offers`,
  PRODUCTS_API_URL: `${apiEnvs.offersPortal}/products`,
  LOYALIZATION_API_URL: `${apiEnvs.offersPortal}/loyalization`,
  EVENTS_API_URL: `${apiEnvs.offersPortal}/events`,
  METRICS_API_URL: `${apiEnvs.offersPortal}/metrics`,
  DEVICES_API_URL: `${apiEnvs.offersPortal}/devices`,
  BUSINESS_RULES_API_URL: `${apiEnvs.offersPortal}/business-rules`,
  FILES_API_URL: `${apiEnvs.offersPortal}/files`,
  CUSTOMER_SEGMENTS_API_URL: `${apiEnvs.offersPortal}/customer-segments`,
  STATUS_API_URL: `${apiEnvs.offersPortal}/status`,
  SALES_CHANNEL_URL: `${apiEnvs.offersPortal}/sales-channel`,

  CALENDAR_ADAPTER_URL: apiEnvs.calendarAdapter,

  DISCOUNTS: [
    { name: 'Zgody marketingowe', code: 'MARKETING_AGREEMENT', value: 5, disabled: true },
    { name: 'eFaktura', code: 'E_INVOICE', value: 5, disabled: true },
    { name: 'Zniżka za posiadane usługi', code: 'SERVICES_DISCOUNT', value: 0, disabled: false }
  ],
  ADMIN_PANEL_URL: 'http://34.244.152.163',
  USER_IP: 'https://ipinfo.io/json',
  FEAT_METRICS: true,
  CAPTCHA_SITE_KEY: apiEnvs.captchaSiteKey
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts